











































































































import Vue from 'vue'
import { getModule } from 'vuex-module-decorators'
import { ResidentModule } from '@/store/modules/resident.module'
import Component from 'vue-class-component'
import {
  EPaymentReceiptType,
  IResidentOpenBalanceItemDTO,
  EAutoPayType,
  EAutoPayOffset
} from '@zunta/configurations'
import { NoCache } from '@/decorators/NoCache'
import Vue2Filters from 'vue2-filters'
import { getNumberDayLabel } from '@/constants'
import Card from '@/components/Card.vue'

import Icon from '@/components/Icon.vue'

const moment = require('moment')

@Component({
  components: { Icon, Card },
  mixins: [Vue2Filters.mixin]
})
export default class AutopaySuccess extends Vue {
  EPaymentReceiptType: any = EPaymentReceiptType
  EAutoPayType: any = EAutoPayType
  EAutoPayOffset: any = EAutoPayOffset
  moment: any = moment

  residentModuleInstance: ResidentModule = getModule(ResidentModule, this.$store)
  getNumberDayLabel: any = getNumberDayLabel
  isEdit: boolean = false

  get residentId () {
    return this.$route.params.residentId
  }

  get scheduleId () {
    return this.$route.params.scheduleId
  }

  get autoPayment () {
    return this.$store.state.resident.selectedAutoPayment
  }

  get openBalance () {
    return this.$store.state.resident.openBalance
  }

  get payablePayerTypes () {
    if (this.autoPayment.appliedTo) {
      return this.autoPayment.appliedTo.payerTypes.map((item: any) => (item.payerName))
    }
    return []
  }

  @NoCache
  get firstEffectiveMonth () {
    if (this.autoPayment) {
      // return moment(new Date(this.autoPayment.firstPaymentDate)).format('MMMM Do, YYYY')
      return moment(this.autoPayment.firstPaymentDate).format('MMMM YYYY')
    }
    return ''
  }

  get amountText () {
    const amount = this.autoPayment.includeSurcharge
        ? (this.autoPayment.amount * 1.0295).toFixed(2)
        : this.autoPayment.amount
    switch (this.autoPayment.paymentType) {
      case EAutoPayType.BILL_MAX_ONLY:
        return `$${amount} <span class="text-orange">Only if the resident has a balance as of the payment date.</span>`
      case EAutoPayType.BILL_ANYWAY:
        return `$${amount} <span class="text-orange">Regardless of the residents balance as of the payment date</span>`
      case EAutoPayType.BILL_MONTH_DUE:
        return 'Total outstanding balance as of the date of payment.'
      case EAutoPayType.BILL_FULL_DUE:
        let text = ''
        switch (this.autoPayment.paymentType) {
          case EAutoPayOffset.CURRENT_MONTH:
            text = 'current'
            break
          case EAutoPayOffset.PREVIOUS_MONTH:
            text = 'previous'
            break
          case EAutoPayOffset.NEXT_MONTH:
            text = 'next'
            break
        }
        return `The ${text} months charges for the selected payers`
      default :
        return ''
    }
  }

  async mounted () {
   this.$eventBus.$emit('loading:enable', { message: 'Loading...' })
    await this.residentModuleInstance.fetchAutoPayment(this.scheduleId)
    setTimeout(() => this.$eventBus.$emit('loading:disable'), 300)
  }

  beforeDestroy () {
    this.residentModuleInstance.resetAutoPayment()
  }

  goBack () {
    this.$locationManager.goBack({ name: 'management-resident', params: { id: this.residentId } })
  }

  beforeRouteEnter (to: any, from: any, next: any) {
    next((vm: any) => {
      vm.isEdit = from.name === 'edit-payment-autopay'
    })
  }
}

